/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SendGridTemplateType = {
    NewRegistrationInvite: 1,
    ManualInvite: 2,
    RegistrationConfirmation: 3,
    ActivationRequired: 4
} as const;
export type SendGridTemplateType = typeof SendGridTemplateType[keyof typeof SendGridTemplateType];

